'use strict';

angular.module('imagetrend.components')
    .controller('hlpMonthYearSelectController', ['$scope', 'Format', function ($scope, Format) {
        $scope.setDate = function (month, year) {
            $scope.innerForm.monthYear.$setDirty();
            if (month == undefined || year == undefined) {
                $scope.ngModel = '';
                if (month == undefined && year == undefined) {
                    $scope.innerForm.monthYear.$setValidity("monthYear", true);
                }
                else {
                    $scope.innerForm.monthYear.$setValidity("monthYear", false);
                }
            }
            else {
                $scope.ngModel = Format.date(new Date(year, month));
                $scope.innerForm.monthYear.$setValidity("monthYear", true);
            }
        }
    }])
    .directive('hlpMonthYearSelect', ['Format', 'Resource', function (Format, Resource) {
        return {
            restrict: 'AE',
            scope: {
                name: '@?',
                id: '@?',
                showLabel: '@?',
                isRequired: '@?',
                isDisabled: '=?',
                change: '&?',
                ngModel: '=',
                question: '=?',
                label: '@?',
                title: '@?',
                requiredText: '@?',
                classes: '@?',
                months: '=?',
                years: '=?',
                yearOffset: '@?',
                yearSpan: '@?'
            },
            replace: true,
            require: 'ngModel',
            templateUrl: 'templates/month-year-select/month-year-select.html',
            link: function (scope, elem, attrs, ctrl) {
                if (!attrs.id) { attrs.id = attrs.name; }
                if (!attrs.label) { attrs.label = Format.label(attrs.name); }
                if (!attrs.showLabel) { attrs.showLabel = attrs.label.length > 0; } else { if (attrs.showLabel == 'true') { attrs.showLabel = true; } else { attrs.showLabel = false; } }
                if (!attrs.isRequired) { attrs.isRequired = false; } else { if (attrs.isRequired == 'true') { attrs.isRequired = true; } else { attrs.isRequired = false; } }
                if (!attrs.title) { attrs.title = Format.label(attrs.name); }
                if (!attrs.requiredText) { attrs.requiredText = 'Please enter a ' + Format.label(attrs.label || attrs.name); }
                if (!attrs.yearOffset) { attrs.yearOffset = 0; }
                if (!attrs.yearSpan) { attrs.yearSpan = 10; }
                if (!attrs.months) { scope.months = Resource.months(); }
                if (!attrs.years) { scope.years = Resource.years(attrs.yearOffset, attrs.yearSpan); }

                elem[0].querySelector('input').focus = function () {
                    var firstInvalid = elem[0].querySelector('select.empty');
                    if (firstInvalid) {
                        firstInvalid.focus();
                    }
                }
            },
            controller: 'hlpMonthYearSelectController'
        };
    }])

;